import type { OrgAuthPolicy, OrgSettings } from "@/types/api";
import { http } from "./http";

/**
 * The narrow set a partner may change about themselves: branding and auto-join
 * domains.
 *
 * Commercial terms — plan, price, seat count, contract dates, status — are NOT
 * here and are not editable by a partner. `settings.hostname` is Curo-controlled
 * too: it selects which org a dashboard renders for, so a partner writing it
 * could point their branding at someone else's address.
 */
export const settingsService = {
	update: (patch: {
		settings?: Omit<OrgSettings, "hostname" | "modules">;
		autoJoinDomains?: string[];
	}) =>
		http.put<{ settings: OrgSettings; auth_policy: OrgAuthPolicy }>(
			"/api/org/settings",
			patch,
		),
};
